import React from 'react';
export * from 'lucide-react';
export const Icon = ({ children, className }) =>
  React.createElement('span', { className }, children);
